@if (isMobileDevice && consoleSession) {
  <div id="log-plugin-container" class="log-content">
    <div class="log-toolbar">
      <div class="log-sticky" [ngClass]="{'enabled': stickToBottom}">
        <fa-icon (click)="toggleStickToBottom()" [icon]="longArrowDown" class="stick-icon" [pTooltip]="stickToBottom ? 'Stop following log' : 'Follow log'" aria-hidden="true"></fa-icon>
      </div>
      <div class="p-field-checkbox">
        <p-checkbox size="small" id="filtering" (onChange)="toggleFilter($event)" [binary]="true" [(ngModel)]="filteringEnabled"></p-checkbox>
        <label class="checkbox-label" for="filtering">Filter Log</label>
      </div>
      <div class="filters">
        <div class="filter-group">
          <fa-icon icon="flag" [ngClass]="{'enabled': filteringEnabled}" [pTooltip]="'Filter log levels'" aria-hidden="true"></fa-icon>
          <p-multiSelect [disabled]="!filteringEnabled" [baseZIndex]="9000000" appendTo="body"
                         [options]="supportedLogTypes" (ngModelChange)="logTypeChanged($event)" [ngModel]="filter.types"
                         [attr.data-testing-id]="getDataTestingIdForPluginType(toolbarPluginType, '', '-advanced-btn')"></p-multiSelect>
        </div>
        @if (logSource == 'Android') {
          <div class="filter-group">
            <fa-icon size="lg" icon="tag" [ngClass]="{'enabled': filteringEnabled}" [pTooltip]="'Filter tags'" aria-hidden="true"></fa-icon>
            <input [disabled]="!filteringEnabled" type="text" pInputText [ngModel]="filter.tag" [value]="filter.tag"
                   (ngModelChange)="tagFilterChanged($event)" placeholder="Tag Filter" class="filter-input">
          </div>
        }
        @if (logSource == 'iOS') {
          <div class="filter-group">
            <fa-icon size="lg" icon="cog" [ngClass]="{'enabled': filteringEnabled}" [pTooltip]="'Filter processes'" aria-hidden="true"></fa-icon>
            <input [disabled]="!filteringEnabled" type="text" pInputText [ngModel]="filter.process" [value]="filter.process"
                   (ngModelChange)="processFilterChanged($event)" placeholder="Process Filter" class="filter-input">
          </div>
        }
        <div class="filter-group">
          <fa-icon size="lg" icon="search" [ngClass]="{'enabled': filteringEnabled}" [pTooltip]="'Search everywhere'" aria-hidden="true"></fa-icon>
          <input [disabled]="!filteringEnabled" type="text" pInputText [ngModel]="filter.message"
                 (ngModelChange)="messageFilterChanged($event)" placeholder="Search">
        </div>
        <div class="filter-group">
          <fa-icon size="lg" icon="calendar" [ngClass]="{'enabled': filteringEnabled}" [pTooltip]="'From time'" aria-hidden="true"></fa-icon>
          <p-date-picker [disabled]="!filteringEnabled" [ngModel]="filter.fromTime" showClear="true" [timeOnly]="true" [showSeconds]="true" inputId="time" (ngModelChange)="fromTimeFilterChanged($event)"></p-date-picker>
        </div>
        <div class="filter-group">
          <fa-icon size="lg" icon="calendar" [ngClass]="{'enabled': filteringEnabled}" [pTooltip]="'To time'" aria-hidden="true"></fa-icon>
          <p-date-picker [disabled]="!filteringEnabled" [ngModel]="filter.toTime" showClear="true" [timeOnly]="true" [showSeconds]="true" inputId="time" (ngModelChange)="toTimeFilterChanged($event)"></p-date-picker>
        </div>
        <div class="filter-group">
          <button pButton class="p-button-secondary" label="Download" (click)="downloadLog()">
            <fa-icon icon="download"></fa-icon>
          </button>
        </div>
      </div>
    </div>
    <div id="logMonitorContainer" class="log-monitor-container">
      <div id="logMonitor" class="log-monitor">
        <cdk-virtual-scroll-viewport [ngStyle]="{ height: contentHeight + 'px'}" [style.padding-bottom.px]="padding" class="virtual-scroll-container" [itemSize]="itemSize">
          <div class="light-theme" *cdkVirtualFor="let log of currentMessages" style="display: table; width: 100%" [style.height.px]="itemSize">
        <span class="msg-item {{'msg-'+(log.type.toLowerCase())}}" >
          <span>
            @switch (log.type) {
              <!--   ANDROID LOG LEVELS   -->
              @case ('VERBOSE') {
                <fa-icon [fixedWidth]="true" icon="ellipsis-v" aria-hidden="true"></fa-icon>
              }
              @case ('WARN') {
                <fa-icon [fixedWidth]="true" icon="exclamation-triangle" aria-hidden="true"></fa-icon>
              }
              @case ('FATAL') {
                <fa-icon [fixedWidth]="true" icon="times-circle" aria-hidden="true"></fa-icon>
              }
              <!--   iOS LOG LEVELS   -->
              @case ('NOTICE') {
                <fa-icon [fixedWidth]="true" icon="circle" aria-hidden="true"></fa-icon>
              }
              @case ('FAULT') {
                <fa-icon [fixedWidth]="true" icon="times-circle" aria-hidden="true"></fa-icon>
              }
              <!--   GENERIC LOG LEVELS   -->
              @case ('DEBUG') {
                <fa-icon [fixedWidth]="true" icon="question" aria-hidden="true"></fa-icon>
              }
              @case ('INFO') {
                <fa-icon [fixedWidth]="true" icon="info" aria-hidden="true"></fa-icon>
              }
              @case ('ERR') {
                <fa-icon [fixedWidth]="true" icon="exclamation-circle" aria-hidden="true"></fa-icon>
              }
              <!--   FALLBACK LOG LEVELS   -->
              @case ('LOG') {
                <fa-icon [fixedWidth]="true" icon="caret-right" aria-hidden="true"></fa-icon>
              }
            }
          </span>
          <div class="timestamp">[{{ log.timestamp }}]: </div>
          @if (log.tag) {
            <div class="tag" [pTooltip]="log.tag">{{ log.tag }} </div>
          }
          @if (log.process) {
            <div class="process" [pTooltip]="log.process">{{ log.process }} </div>
          }
          <div #msg class="message">{{ log.message }}</div>
        </span>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
  </div>
} @else if (consoleSession) {
  <p>Log not available.</p>
} @else {
  <p>No active mobile console.</p>
}

